import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class AutoLoginGuard  {
    constructor(
        private readonly authService: AuthService,
        private readonly router: Router,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        // tslint:disable-next-line: no-string-literal
        let loggedInStatus = false;
        return this.authService.loggedIn.pipe(
            map(
                response => {
                    loggedInStatus = response;
                    if (loggedInStatus) {
                        this.router.navigate(['/tabs/home']);
                    }
                    return true;
                },
                error => {
                    return loggedInStatus;
                }
            )
        );
    }
}
